export const BaseTableHelpers = () => {    

    const FindInBaseTableFromId = (baseTableList, id) => {
        return baseTableList.filter((item) => item.id === id)[0]
    }
    const FindKeyInBaseTableFromIdOrDefault = (baseTableList,id)=> {
        return baseTableList.filter((item) => item.id === id)[0]?.key || baseTableList.filter((item) => item.id === 1)[0]?.key
    }
    const FindIdInBaseTableFromIdentificativoOrDefault = (baseTableList, identificativo) => {
        return baseTableList.filter((item) => item.identificativo === identificativo)[0]?.id || baseTableList.filter((item) => item.id === 1)[0]?.id
    }
    const GetTabelleBase = () => {
        return [    
            { id: "base_mezzo_pagamento", name: "Mezzo di pagamento" },   
            { id: "base_origine_fondi", name: "Origine dei fondi" },   
            { id: "base_tipo_documento", name: "Tipologia documento" },    
        ];
    }
    const GetTabelleBaseExtra = () => {
        return [
            { id: "base_paese", name: "Nazioni" },
            { id: "base_provincia", name: "Province" },
            { id: "base_comune", name: "Comuni" }            
        ];
    }
    const GetTabelle = () => {
        return [
            { id: "fascicolo", name: "Fascicoli" },
            { id: "prestazione", name: "Prestazioni" },
            { id: "rischio", name: "Rischi" },
            { id: "indicatore_anomalia", name: "Indicatori Anomalia" },
            { id: "anagrafica", name: "Anagrafiche" },
            { id: "allegato", name: "Allegati" },
            { id: "azienda", name: "Aziende" },
            { id: "tenant", name: "Tenant" },
            { id: "user", name: "Utenti" },
            { id: "sos", name: "Segnalazioni operazioni sospette" },
            { id: "autovalutazione", name: "Autovalutazioni" },
        ];
    }    

    return {
        FindInBaseTableFromId,
        FindKeyInBaseTableFromIdOrDefault,
        FindIdInBaseTableFromIdentificativoOrDefault,
        GetTabelleBase,
        GetTabelleBaseExtra,
        GetTabelle        
    }
}

// Export standalone functions for backward compatibility
export const getTabelleBase = () => {
    return [    
        { id: "base_mezzo_pagamento", name: "Mezzo di pagamento" },   
        { id: "base_origine_fondi", name: "Origine dei fondi" },   
        { id: "base_tipo_documento", name: "Tipologia documento" },    
    ];
}
export const getTabelleBaseExtra = () => {
    return [
        { id: "base_paese", name: "Nazioni" },
        { id: "base_provincia", name: "Province" },
        { id: "base_comune", name: "Comuni" },
    ];
}
export const getTabelle = () => {
    return [
        { id: "fascicolo", name: "Fascicoli" },
        { id: "prestazione", name: "Prestazioni" },
        { id: "rischio", name: "Rischi" },
        { id: "indicatore_anomalia", name: "Indicatori Anomalia" },
        { id: "anagrafica", name: "Anagrafiche" },
        { id: "allegato", name: "Allegati" },
        { id: "azienda", name: "Aziende" },
        { id: "tenant", name: "Tenant" },
        { id: "user", name: "Utenti" },
        { id: "sos", name: "Segnalazioni operazioni sospette" },
        { id: "autovalutazione", name: "Autovalutazioni" },
    ];
}